import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

import { exchangeCodeForSession } from "@/actions/terminal-auth-actions"
import { getTerminalHeadMeta } from "@/lib/terminal/metadata"

export const Route = createFileRoute("/terminal/auth/callback")({
  head: () => ({
    meta: getTerminalHeadMeta(),
  }),
  validateSearch: z.object({
    code: z.string().optional(),
  }),
  beforeLoad: async ({ search }) => {
    if (!search.code) {
      throw redirect({ to: "/terminal/login" })
    }
    const result = await exchangeCodeForSession({ data: { code: search.code } })
    if (result.hasError) {
      throw redirect({
        to: "/terminal/login",
        search: { error: result.errorType },
      })
    }
    throw redirect({
      to: "/terminal",
      search: {},
    })
  },
  component: () => null,
})
